(function(){
'use strict';
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
function num(el,a,d){var v=parseFloat(el.getAttribute(a));return isNaN(v)?d:v;}
function isShop(u){return u&&(u.indexOf('cdn.shopify.com')>-1||u.indexOf('/cdn/shop/')>-1);}
function opt(u,w){
  if(!u||!isShop(u))return u;
  if(u.indexOf('format=')>-1)return u;
  return u+(u.indexOf('?')>-1?'&':'?')+'width='+w+'&format=jpg';
}
/* cut-outs must keep their alpha, so width only — never format=jpg */
function optPng(u,w){
  if(!u||!isShop(u))return u;
  if(u.indexOf('width=')>-1)return u;
  return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;
}
/* DESKTOP WIDTHS MATCH THE MASTERS ON PURPOSE.
   Shopify never upscales — ?width=N returns min(N, source width) — and when N equals the
   source width the CDN serves the file untouched, with no resample at all. The cut-out
   masters are the 5400x3600 -xl files (Shopify's 20-megapixel cap is why they are not
   bigger; the 9000px original failed processing at 54MP). The photo master is 4400, so
   its 5000 simply means "the whole file". Mobile is deliberately smaller: PNGs with
   alpha get large fast and phone bandwidth is worth more than pixels a phone cannot
   show. Measured at 1440 CSS px on a 2x screen the camera needs ~5040 device px. */
var W_PHOTO_D=5000,W_PHOTO_M=3600,W_CUT_D=5400,W_CUT_M=1700;
function setup(sec){
  if(sec.__t)return;
  /* A section hidden by a media query must not set up at all: measure() calls loadImg()
     before it checks anything, so an invisible section would still download the full-size
     team photo. Deliberately NOT marked as done — run() is retried on resize, so it
     initialises the moment it becomes visible. */
  if(!sec.offsetWidth&&!sec.offsetHeight)return;
  sec.__t=1;
  var mode=sec.getAttribute('data-mode')||'cam';
  if(reduce)mode='focus';
  var stage=sec.querySelector('.i5t-stage'),cam=sec.querySelector('.i5t-cam'),cam2=sec.querySelector('.i5t-cam2'),
      full=sec.querySelector('.i5t-full');
  var cards=[].slice.call(sec.querySelectorAll('.i5t-card')),dots=[].slice.call(sec.querySelectorAll('.i5t-dot')),
      bigs=[].slice.call(sec.querySelectorAll('.i5t-bigname')),cuts=[].slice.call(sec.querySelectorAll('.i5t-cut'));
  var rail=sec.querySelector('.i5t-rail');
  var n=cards.length;if(!n||!cam)return;
  var geo=null,imgW=0,imgH=0,cur=-1,loadedFor='',onReady=null;
  /* The big photo is the heaviest single file on the page (~800KB at master width, and
     it must stay that size: the camera zoom resamples it, and a smaller file blurs the
     faces it zooms into). What is negotiable is WHEN — nobody pays for it until the
     section is within a screen and a half of the viewport. */
  var near=false;
  if('IntersectionObserver' in window){
    var nio=new IntersectionObserver(function(es){
      if(es[0]&&es[0].isIntersecting){near=true;nio.disconnect();loadImg();}
    },{rootMargin:'150% 0px'});
    nio.observe(sec);
  }else{near=true;}
  function desk(){return innerWidth>=761;}
  function src(){var d=sec.getAttribute('data-img-d'),m=sec.getAttribute('data-img-m');return desk()?opt(d,W_PHOTO_D):opt(m||d,W_PHOTO_M);}
  function focal(i){var c=cards[i],d=desk();return {x:num(c,d?'data-dx':'data-mx',50)/100,y:num(c,d?'data-dy':'data-my',45)/100};}
  function zoom(){return (desk()?num(sec,'data-zd',210):num(sec,'data-zm',175))/100;}
  /* THE SECTION HAS ALREADY STAMPED A ?width= BY THE TIME WE GET HERE, from its Cut-out
     resolution setting. Take the LARGER of that and what this viewport needs — never the
     smaller, so a deliberate per-designer override can still pin a bigger file. This is
     why an earlier pass that only raised W_CUT_D changed nothing: optPng leaves a URL
     that already carries width= completely alone. */
  function cutUrl(u){
    var want=desk()?W_CUT_D:W_CUT_M;
    var m=/[?&]width=(\d+)/.exec(u);
    if(!m)return optPng(u,want);
    return (+m[1])>=want?u:u.replace(/([?&])width=\d+/,'$1width='+want);
  }
  function ensureCut(i){
    var c=cuts[i];if(!c||c.__l)return;
    var u=c.getAttribute('data-cut');if(!u)return;
    /* The cut-outs ARE the outline — they are what lets the highlight follow one person
       instead of the whole photo, at every width. Do not skip them on desktop. */
    c.__l=1;c.style.backgroundImage='url("'+cutUrl(u)+'")';
  }
  function ensureAround(i){if(i<0){ensureCut(0);return;}ensureCut(i);if(i+1<cuts.length)ensureCut(i+1);if(i>0)ensureCut(i-1);}
  function railTo(i){
    if(i<0||!rail||!dots[i])return;
    if(rail.scrollWidth<=rail.clientWidth+2)return;
    var max=rail.scrollWidth-rail.clientWidth;
    var d=dots[i],left=d.offsetLeft-(rail.clientWidth-d.offsetWidth)/2;
    if(left<0)left=0;
    if(left>max)left=max;
    /* RTL scroll containers count scrollLeft from 0 down to -max (Arabic page),
       so the LTR coordinate is shifted into that range before scrolling */
    if(getComputedStyle(rail).direction==='rtl')left-=max;
    if(rail.scrollTo)rail.scrollTo({left:left,behavior:'smooth'});
    else rail.scrollLeft=left;
  }
  function loadImg(){
    if(!near)return;
    var u=src();if(!u||u===loadedFor)return;loadedFor=u;
    var im=new Image();
    im.onload=function(){imgW=im.naturalWidth;imgH=im.naturalHeight;geo=null;full.style.backgroundImage='url("'+u+'")';if(onReady)onReady();};
    im.src=u;
  }
  /* THE PHOTO SCALE MUST NOT FOLLOW THE VIEWPORT.
     iOS collapses its toolbar as you scroll, so dvh grows, the stage gets taller, and a
     plain cover scale re-zooms the photo mid-scroll — which reads as the picture randomly
     changing size. Lock the cover scale to the LARGE viewport height (measured once with a
     100lvh probe) so the framing is identical on the first frame and every frame after.
     Where lvh is unsupported the probe measures 0 and we fall back to the live height.
     Re-probed only when the WIDTH changes, so a toolbar collapse never disturbs it. */
  var refW=0,refH=0;
  function lockedH(W,H){
    if(W!==refW){refW=W;refH=0;}
    if(!refH){
      var p=document.createElement('div');
      p.style.cssText='position:absolute;left:0;top:0;width:0;height:100lvh;visibility:hidden;pointer-events:none';
      sec.appendChild(p);refH=p.offsetHeight||0;sec.removeChild(p);
    }
    return refH>H?refH:H;
  }
  function measure(){
    loadImg();
    var W=stage.clientWidth,H=stage.clientHeight;
    if(!W||!H||!imgW||!imgH)return false;
    var RH=lockedH(W,H);
    var s=Math.max(W/imgW,RH/imgH),w=imgW*s,h=imgH*s;
    geo={W:W,H:H,l:(W-w)/2,t:(H-h)/2,w:w,h:h,src:imgW};
    [cam,cam2].forEach(function(el){if(!el)return;el.style.left=geo.l+'px';el.style.top=geo.t+'px';el.style.width=w+'px';el.style.height=h+'px';});
    return true;
  }
  function capZoom(z){
    if(!geo||!geo.src)return z;
    var dpr=Math.min(devicePixelRatio||1,2.5);
    var maxZ=(geo.src*1.7)/(geo.w*dpr);
    if(maxZ<1.5)maxZ=1.5;
    return Math.min(z,maxZ);
  }
  function place(fx,fy,z){
    if(!geo&&!measure())return;
    var g=geo;
    var tx=g.W*(desk()?0.42:0.5),ty=g.H*(desk()?0.52:0.44);
    var t='translate3d('+(tx-g.l-z*fx*g.w).toFixed(1)+'px,'+(ty-g.t-z*fy*g.h).toFixed(1)+'px,0) scale('+z.toFixed(3)+')';
    cam.style.transform=t;
    if(cam2)cam2.style.transform=t;
  }
  function ease(u){return u*u*(3-2*u);}
  if(mode==='cam'){
    sec.classList.add('is-scrub');
    var vh=innerHeight,tick=false,lastAi=-1;
    var frame=function(){
      var r=sec.getBoundingClientRect(),total=sec.offsetHeight-vh;
      var p=total>0?Math.min(1,Math.max(0,-r.top/total)):0;
      var intro=0.10,Z=capZoom(zoom()),fx,fy,z,ai,alpha;
      if(p<intro){
        var k=ease(p/intro),f0=focal(0),cy=desk()?0.46:0.48;
        fx=0.5+(f0.x-0.5)*k;fy=cy+(f0.y-cy)*k;z=1+(Z-1)*k;ai=0;alpha=Math.max(0,k*2-1);
      }else{
        var q=(p-intro)/(1-intro),t=q*(n-1);
        var i=n>1?Math.min(n-2,Math.floor(t)):0,f=n>1?t-i:0;
        var u=ease(Math.min(1,Math.max(0,(f-0.22)/0.56)));
        var a=focal(i),b=focal(Math.min(n-1,i+1));
        fx=a.x+(b.x-a.x)*u;fy=a.y+(b.y-a.y)*u;
        z=Z*(1-0.1*Math.sin(u*Math.PI));
        ai=u<0.5?i:Math.min(n-1,i+1);
        alpha=Math.min(1,(u<0.5?1-u*2:u*2-1)*1.2);
      }
      place(fx,fy,z);
      for(var k2=0;k2<n;k2++){var c=cards[k2];
        if(k2===ai){c.classList.add('on');c.style.opacity=alpha;c.style.transform='translateY('+((1-alpha)*16).toFixed(1)+'px)';}
        else if(c.style.opacity!=='0'){c.classList.remove('on');c.style.opacity='0';}}
      for(var kb=0;kb<bigs.length;kb++){var bg=bigs[kb];
        if(kb===ai){bg.style.opacity=alpha;}
        else if(bg.style.opacity!=='0'){bg.style.opacity='0';}}
      for(var kc=0;kc<cuts.length;kc++){var ct=cuts[kc];
        if(kc===ai){ct.classList.add('on');ct.style.opacity=alpha;}
        else if(ct.style.opacity!=='0'){ct.classList.remove('on');ct.style.opacity='0';}}
      for(var k3=0;k3<dots.length;k3++)dots[k3].classList.toggle('on',k3===ai);
      if(ai!==lastAi){lastAi=ai;railTo(ai);ensureAround(ai);}
      var pr=sec.querySelector('.i5t-prog');if(pr)pr.style.setProperty('--p',p.toFixed(4));
      var fade=Math.max(0,1-p*9).toFixed(2);
      sec.style.setProperty('--hint',fade);
      sec.style.setProperty('--headop',fade);
      tick=false;
    };
    onReady=function(){measure();frame();};
    addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(frame);}},{passive:true});
    addEventListener('resize',function(){vh=innerHeight;geo=null;loadImg();measure();frame();},{passive:true});
    measure();frame();ensureCut(0);
    dots.forEach(function(d,i){d.addEventListener('click',function(){
      var total=sec.offsetHeight-innerHeight,intro=0.10;
      var q=n>1?i/(n-1):0,p=intro+q*(1-intro);
      var top=sec.getBoundingClientRect().top+scrollY;
      scrollTo({top:top+total*Math.min(1,p),behavior:'smooth'});
    });});
  }else{
    sec.classList.add('is-focus');
    sec.style.setProperty('--headop','1');
    /* INTRO STATE (index -1) — the whole team photo, un-zoomed, nobody selected.
       Only for sections that declare data-intro. This lives in the engine on purpose: an
       earlier build drove it from the section's own script and the two fought each other,
       which skipped Manal and flashed the heading over a designer. ONE owner. */
    var introMode=sec.hasAttribute('data-intro');
    /* WALK ORDER. null = every designer in block order. A branch button sets it to just
       that branch's indices, so "Dubai" walks Yasmin > Fouad > Dima and stops at the ends
       of ITS OWN list rather than wandering into the other branch. Cleared whenever the
       visitor steps outside the branch: a direct tap on a name, or back to the photo. */
    var order=null;
    sec.addEventListener('i5tw:order',function(e){
      var l=e&&e.detail&&e.detail.list;
      order=(l&&l.length)?l.slice():null;
    });
    var auto=sec.getAttribute('data-auto')==='1'&&!reduce,delay=num(sec,'data-delay',5)*1000,timer=null;
    var restart=function(){if(!auto)return;clearInterval(timer);timer=setInterval(function(){go(cur+1>=n?0:cur+1);},delay);};
    var go=function(i,user){
      if(i<0&&!introMode)i=0;
      cur=i;
      if(!geo&&!measure())return;
      if(i<0){
        order=null;                       /* back at the photo — no branch is selected */
        sec.setAttribute('data-intro','1');
        cam.style.transform='none';if(cam2)cam2.style.transform='none';
        cards.forEach(function(c){c.classList.remove('on');});
        bigs.forEach(function(b){b.style.opacity=0;});
        cuts.forEach(function(c){c.classList.remove('on');c.style.opacity=0;});
        dots.forEach(function(d){d.classList.remove('on');});
        ensureCut(0);
        if(user)restart();
        return;
      }
      if(introMode)sec.setAttribute('data-intro','0');
      var f=focal(i);
      ensureAround(i);
      place(f.x,f.y,capZoom(zoom()));
      cards.forEach(function(c,k){c.classList.toggle('on',k===i);});
      bigs.forEach(function(b,k){b.style.opacity=k===i?1:0;});
      cuts.forEach(function(c,k){c.classList.toggle('on',k===i);c.style.opacity=k===i?1:0;});
      dots.forEach(function(d,k){d.classList.toggle('on',k===i);});
      railTo(i);
      if(user)restart();
    };
    /* the ONLY gesture handler. dir>0 = forward. From the opening photo the first move
       lands on the first designer of whatever list is active; going back off the front
       returns to the opening photo. */
    function swipe(dir){
      if(order&&order.length){
        var k=order.indexOf(cur);
        if(k<0){go(order[dir>0?0:order.length-1],true);return;}
        var nk=k+(dir>0?1:-1);
        if(nk>=order.length){go(introMode?-1:order[0],true);return;}
        if(nk<0){go(introMode?-1:order[order.length-1],true);return;}
        go(order[nk],true);return;
      }
      if(dir>0){go(cur<0?0:(cur+1>=n?(introMode?-1:0):cur+1),true);return;}
      go(cur<=0?(introMode?-1:n-1):cur-1,true);
    }
    onReady=function(){measure();go(cur);};
    /* a direct tap on a name is a deliberate step outside any branch walk */
    dots.forEach(function(d,i){d.addEventListener('click',function(){order=null;go(i,true);});});
    var sx=null;
    stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    stage.addEventListener('touchend',function(e){
      if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;
      if(Math.abs(dx)>50)swipe(dx<0?1:-1);
    },{passive:true});
    var px=null;
    stage.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')return;px=e.clientX;});
    stage.addEventListener('pointerup',function(e){
      if(e.pointerType==='touch'||px===null)return;
      var dx=e.clientX-px;px=null;
      if(Math.abs(dx)>45)swipe(dx<0?1:-1);
    });
    stage.addEventListener('pointercancel',function(){px=null;});
    stage.addEventListener('dragstart',function(e){e.preventDefault();});
    sec.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){swipe(1);e.preventDefault();}
      else if(e.key==='ArrowLeft'){swipe(-1);e.preventDefault();}
    });
    sec.setAttribute('tabindex','-1');
    sec.addEventListener('pointerenter',function(){clearInterval(timer);});
    sec.addEventListener('pointerleave',restart);
    addEventListener('resize',function(){geo=null;loadImg();measure();go(cur);},{passive:true});
    cur=introMode?-1:0;
    measure();go(cur);
    if(auto)restart();
  }
}
function run(){[].forEach.call(document.querySelectorAll('[data-i5team]'),setup);}
if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
/* retried on resize so a section that was hidden at load (desktop/mobile split) sets
   itself up the moment a breakpoint makes it visible. setup() no-ops on ones already done. */
addEventListener('resize',run,{passive:true});
if(window.Shopify&&Shopify.designMode)document.addEventListener('shopify:section:load',function(){[].forEach.call(document.querySelectorAll('[data-i5team]'),function(s){s.__t=null;});run();});
})();
